import React, { Component } from 'react';

class PostLoading extends Component {
    render() {
        return (
            <div className="loading">
                <div style={{ "transitionDelay": `${1 * .25}s` }}>
                    <h2>Loading</h2>
                </div>
                <div style={{ "transitionDelay": `${2 * .25}s` }}>
                    <h2>Loading</h2>
                </div>
                <div style={{ "transitionDelay": `${3 * .25}s` }}>
                    <h2>Loading</h2>
                </div>
                <div style={{ "transitionDelay": `${4 * .25}s` }}>
                    <h2>Loading</h2>
                </div>
            </div>

        );
    }
}

export default PostLoading;



// WEBPACK FOOTER //
// ./src/Posts/PostLoading.js